import { defineRoutes, setOutlet, setLayoutSetter, onRouteChange, startRouter } from './router/index.js';
import { buildShell, setActiveNav, setPageTitle, applySavedTheme } from './components/layout.js';
import { el } from './utils/dom.js';

import LoginPage   from './pages/auth/login.js';
import DashboardPage  from './pages/dashboard/index.js';
import InventoryListPage from './pages/inventory/list.js';
import InventoryFormPage from './pages/inventory/form.js';
import InventoryDetailPage from './pages/inventory/detail.js';
import CategoriesPage from './pages/catalog/categories.js';
import SubcategoriesPage from './pages/catalog/subcategories.js';
import LocationsPage  from './pages/catalog/locations.js';
import ClientsPage     from './pages/people/clients.js';
import ResponsiblesPage from './pages/people/responsibles.js';
import LoansListPage   from './pages/loans/list.js';
import LoansFormPage   from './pages/loans/form.js';
import LoansDetailPage from './pages/loans/detail.js';
import RentalsListPage   from './pages/rentals/list.js';
import RentalsFormPage   from './pages/rentals/form.js';
import RentalsDetailPage from './pages/rentals/detail.js';
import RentalsCreditoPage from './pages/rentals/credito.js';
import RentalsAjustesPage from './pages/rentals/ajustes.js';
import CalendarioPage from './pages/rentals/calendario.js';
import MisEntregasPage from './pages/rentals/mis-entregas.js';
import EtiquetasPage from './pages/rentals/etiquetas.js';
import EsperaPage from './pages/rentals/espera.js';
import ReportePage from './pages/rentals/reporte.js';
import MensajesPage from './pages/rentals/mensajes.js';
import GooglePage from './pages/rentals/google.js';
import ReservationsListPage from './pages/reservations/list.js';
import ReservationsFormPage from './pages/reservations/form.js';
import ReservationsDetailPage from './pages/reservations/detail.js';
import ReservationsCalendarPage from './pages/reservations/calendar.js';
import MaintenanceListPage from './pages/maintenance/list.js';
import MaintenanceFormPage from './pages/maintenance/form.js';
import MaintenanceDetailPage from './pages/maintenance/detail.js';
import ReportsPage from './pages/reports/index.js';
import UsersPage   from './pages/admin/users.js';
import SettingsPage from './pages/admin/settings.js';

applySavedTheme();

const PAGE_TITLES = {
  '/':              'Dashboard',
  '/inventory':     'Inventario',
  '/categories':    'Categorias',
  '/subcategories': 'Subcategorias',
  '/locations':     'Ubicaciones',
  '/clients':       'Clientes',
  '/responsibles':  'Responsables',
  '/loans':         'Prestamos',
  '/rentals':       'Rentas',
  '/rentals/credito': 'Clientes de confianza',
  '/rentals/ajustes': 'Ajustes de rentas',
  '/calendario':    'Calendario',
  '/mis-entregas':  'Mis entregas',
  '/etiquetas':     'Etiquetas QR',
  '/rentals/espera': 'Lista de espera',
  '/rentals/reporte': 'Reporte de ocupación',
  '/rentals/mensajes': 'Mensajes y WhatsApp',
  '/calendario/google': 'Google Calendar',
  '/reservations':  'Reservas',
  '/reservations/calendar': 'Calendario de reservas',
  '/maintenance':   'Mantenimiento',
  '/reports':       'Reportes',
  '/users':         'Usuarios',
  '/settings':      'Configuracion',
};

defineRoutes([
  { path: '/login', render: LoginPage },
  { path: '/',      render: DashboardPage },

  { path: '/inventory',          render: InventoryListPage },
  { path: '/inventory/new',      render: InventoryFormPage },
  { path: '/inventory/:id',      render: InventoryDetailPage },
  { path: '/inventory/:id/edit', render: InventoryFormPage },

  { path: '/categories',    render: CategoriesPage },
  { path: '/subcategories', render: SubcategoriesPage },
  { path: '/locations',     render: LocationsPage },

  { path: '/clients',      render: ClientsPage },
  { path: '/responsibles', render: ResponsiblesPage },

  { path: '/loans',          render: LoansListPage },
  { path: '/loans/new',      render: LoansFormPage },
  { path: '/loans/:id',      render: LoansDetailPage },

  { path: '/rentals',        render: RentalsListPage },
  { path: '/rentals/new',    render: RentalsFormPage },
  { path: '/rentals/credito', render: RentalsCreditoPage },
  { path: '/rentals/ajustes', render: RentalsAjustesPage },
  { path: '/rentals/espera',  render: EsperaPage },
  { path: '/rentals/reporte', render: ReportePage },
  { path: '/rentals/mensajes', render: MensajesPage },
  { path: '/calendario/google', render: GooglePage },
  { path: '/calendario',     render: CalendarioPage },
  { path: '/mis-entregas',   render: MisEntregasPage },
  { path: '/etiquetas',      render: EtiquetasPage },
  { path: '/rentals/:id',    render: RentalsDetailPage },

  { path: '/reservations',          render: ReservationsListPage },
  { path: '/reservations/calendar', render: ReservationsCalendarPage },
  { path: '/reservations/new',      render: ReservationsFormPage },
  { path: '/reservations/:id',      render: ReservationsDetailPage },

  { path: '/maintenance',          render: MaintenanceListPage },
  { path: '/maintenance/new',      render: MaintenanceFormPage },
  { path: '/maintenance/:id',      render: MaintenanceDetailPage },

  { path: '/reports',  render: ReportsPage },
  { path: '/users',    render: UsersPage },
  { path: '/settings', render: SettingsPage },
]);

const appRoot = document.getElementById('app');
const outlet  = el('div', { id: 'outlet' });
let shell = null;

setOutlet(outlet);
setLayoutSetter((withChrome) => {
  if (withChrome) {
    if (!shell) {
      shell = buildShell(outlet);
      appRoot.replaceChildren(shell);
    } else if (!appRoot.contains(shell)) {
      appRoot.replaceChildren(shell);
    }
  } else {
    appRoot.replaceChildren(outlet);
    shell = null;
  }
});

onRouteChange((path) => {
  setActiveNav(rootOf(path));
  const t = PAGE_TITLES[path] || PAGE_TITLES[rootOf(path)] || '—';
  setPageTitle(t);
});

function rootOf(path) {
  if (path === '/') return '/';
  const parts = path.split('/').filter(Boolean);
  return '/' + (parts[0] || '');
}

startRouter();
